import {useCallback} from 'react';

import {
  NotificationContent,
  NotificationItem,
} from '../components/core/Notifications/Notification';
import {NotificationItemProps} from '../components/core/Notifications/Notifications';
import {useNotificationsStore} from './useNotificationStore';

type NotifyCallback = (content: NotificationContent, duration?: number) => void;

export const useNotifications = () => {
  const addNotification = useNotificationsStore(state => state.addNotification);

  const notify = useCallback(
    (
      notification: NotificationItemProps = {
        variant: 'custom',
      },
    ) => {
      if (!notification.id) {
        notification.id = `${Date.now()}`;
      }

      addNotification(notification as NotificationItem);
    },
    [addNotification],
  );

  const notifySuccess = useCallback<NotifyCallback>(
    (content, duration) => notify({variant: 'success', content, duration}),
    [notify],
  );

  const notifyError = useCallback<NotifyCallback>(
    (content, duration) => notify({variant: 'error', content, duration}),
    [notify],
  );

  return {
    notify,
    notifySuccess,
    notifyError,
  };
};
